import { render, staticRenderFns } from "./weier_process_label.vue?vue&type=template&id=79f94a20&scoped=true&"
import script from "./weier_process_label.vue?vue&type=script&lang=js&"
export * from "./weier_process_label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f94a20",
  null
  
)

export default component.exports